import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';


const UploadSuccess = (props) => {

    //useEffect(() => {
    //    console.log("Hi");
    //}, []);

    return (
        <Grid container spacing={0}>
            <Grid container justify="center">
                <Grid item >
                    <h3>Sukses! Jou inskrywing is opgelaai!</h3>
                </Grid>
            </Grid>
        </Grid>

    );
}

export default UploadSuccess;


// WEBPACK FOOTER //
// ./src/components/UploadSuccess.js